import { Table } from '@tanstack/react-table';
import { useState } from 'react';

import { Ticket } from '@work4all/models/lib/Classes/Ticket.entity';
import { TicketFilter } from '@work4all/models/lib/Classes/TicketFilter.entity';
import { TicketKind } from '@work4all/models/lib/Classes/TicketKind.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useLeftAreaVisibleFiltersState } from '../../../../hooks/use-left-area-visible-filters';
import { PersonalAndGeneralViewV8 } from '../../../filters/PersonalAndGeneralView/v8';
import { TableQuickFilters } from '../../table-quick-filters';

import { KindFilters } from './filters/KindFilters';

type TicketsTableQuickFiltersProps = {
  table: Table<Ticket>;
};

export function TicketsTableQuickFilters(props: TicketsTableQuickFiltersProps) {
  const { table } = props;

  const [selectedFilter, setSelectedFilter] = useState<
    TicketFilter | TicketKind
  >();

  const { isFilterVisible } = useLeftAreaVisibleFiltersState({
    entity: Entities.ticket,
    filterIds: ['personal', 'general'],
  });

  return (
    <TableQuickFilters>
      <KindFilters
        table={table}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
      />
      <PersonalAndGeneralViewV8<TicketFilter | TicketKind>
        table={table}
        value={selectedFilter}
        onChange={(value) => {
          setSelectedFilter(value);
        }}
        entity={Entities.ticket}
        hidePersonalFilters={!isFilterVisible('personal')}
        hideGeneralFilters={!isFilterVisible('general')}
      />
    </TableQuickFilters>
  );
}
